import {
  ProjectMapTemplate,
  PhaseTemplateUpdate,
  PhaseTemplateSplitRequest,
} from '@beeboard/common';
import {
  checkTemplateAppendPhase,
  checkTemplateRemovePhase,
  checkTemplateUpdatePhase,
  isUserTemplateEditorOrAbove,
  validateTemplateSplitPhaseRequest,
} from '@beeboard/common';
import { defineStore } from 'pinia';
import { useProfileStore } from './profileStore';
import { useTemplateStore } from './templateStore';

export const usePhaseTemplateRulesStore = defineStore(
  'phaseTemplateRulesStore',
  {
    getters: {
      user() {
        return useProfileStore().profile;
      },
      template() {
        return (templateId: string): ProjectMapTemplate => {
          const template = useTemplateStore().template(templateId);

          return template;
        };
      },
      editorsTemplate() {
        return (templateId: string) => {
          const template = useTemplateStore().editorsTemplate(templateId);

          return template;
        };
      },
    },
    actions: {
      isUserTemplateEditorOrAbove(templateId: string) {
        return !isUserTemplateEditorOrAbove(
          this.user.id,
          this.template(templateId).owner,
          this.editorsTemplate(templateId),
        ).length;
      },
      checkAddPhase(
        templateId: string,
        payload: PhaseTemplateUpdate,
        before?: string,
      ) {
        return checkTemplateAppendPhase(
          this.user.id,
          this.template(templateId),
          before,
          payload,
          this.editorsTemplate(templateId),
        );
      },
      checkRemovePhase(templateId: string, phaseId: string) {
        return checkTemplateRemovePhase(
          this.user.id,
          this.template(templateId),
          phaseId,
          this.editorsTemplate(templateId),
        );
      },
      checkUpdatePhase(
        templateId: string,
        phaseId: string,
        updateRequest: PhaseTemplateUpdate,
      ) {
        return checkTemplateUpdatePhase(
          this.user.id,
          this.template(templateId),
          updateRequest,
          phaseId,
          this.editorsTemplate(templateId),
        );
      },

      validateSplitPhaseRequest(
        templateId: string,
        phaseId: string,
        payload: PhaseTemplateSplitRequest,
      ) {
        return validateTemplateSplitPhaseRequest(
          this.template(templateId),
          phaseId,
          payload,
        );
      },
    },
  },
);
